//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        // Navigates user to degrees and Programs page.
        $("#programFinderBtn").on("click", function(e){

            e.preventDefault();

            // Get values of filters dropdowns. 
            var interest = $("#pickInterest").val();
            var subject = $("#pickSubject").val();

            var params = { Interest:interest, Subject:subject };
            var href = window.curry.degreesandprogramsPage;
            href += (href.match(/\?/) ? '&' : '?') + jQuery.param(params);
            
            window.location.href = href + window.curry.degreesandprogramsPageTab;
        });

    }

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/programFinder.js